import InputFieldBS from './InputFieldBS.jsx';

export default InputFieldBS;